<template>
    <div class="form_fields">
        <div class="form_btns top_btns">
            <button class="secondary_btn" @click="cancelChanges">Cancel</button>
            <button class="primary_btn" @click="updateScene">Submit</button>
        </div>

        <div class="field_block">
            <span class="field_name">Rotation <span v-if="editData.rotation !== 0"> ({{ Math.round(editData.rotation * 100) / 100 }})</span></span>
            <range-slider class="slider" min="-180" max="180" step="1" v-model="editData.rotation" @input="changeRotation">
            </range-slider>
        </div>
        <div class="field_block">
          <ValidationProvider
              name="name"
              v-slot="{ errors }"
              slim
              rules="required"
          >
            <label :class="{ has_error: errors[0] }">
              <span class="field_name">Name</span>
              <input name="name" maxlength="20" v-model="editData.text" @input="changeSceneText"/>
              <span class="error_message">{{
                  errors[0] ? "Required field" : ""
              }}</span>
            </label>
          </ValidationProvider>
        </div>
        <div class="field_block">
            <div class="check_group">
                <label>
                    <input
                        type="checkbox"
                        v-model="editData.rectangular"
                        @change="changeSceneShape"
                    />
                    <span class="check_btn">Rectangular Shape</span>
                </label>
            </div>
        </div>
        <div class="field_block">
            <div class="check_group">
                <label>
                    <input
                        type="checkbox"
                        v-model="editData.hideTitle"
                        @change="changeSceneTitleVisibility"
                    />
                    <span class="check_btn">Hide Stage Name</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import RangeSlider from "vue-range-slider";
    import {
        cancelSceneChanges,
        rotateScene,
        updateSceneStage,
        changeSceneText,
        changeSceneShape,
        changeSceneTitleVisibility
    } from "@/helpers/stage/generator";

    import {
        deselectGroup,
        unFreezeAllGroups
    } from "@/helpers/utils";

    export default {
        props: {
            editScene: {
                type: Object,
                default: () => { },
            },
            popup: {
                type: Boolean,
                default: false,
            },
        },
        watch: {
            popup(opened) {
            if (!opened) {
                cancelSceneChanges(this.editScene);
            }
            },
        },
        data() {
            return {
                editData: {},
            };
        },
        created() {
            this.editData = _.cloneDeep(this.editScene);
        },
        methods: {
            editSceneHelper() {
                const { layerId } = this.editScene;
                
                const payload = {
                    sceneData: this.editScene,
                    newData: this.editData,
                };
                updateSceneStage(layerId, payload);
            },
            updateScene() {
                deselectGroup();
                this.$emit("closePopup");
                unFreezeAllGroups();
            },
            cancelChanges() {
                cancelSceneChanges(this.editScene)
                this.$emit("closePopup", this.editScene);
                unFreezeAllGroups();
            },
             changeRotation() {
                
                rotateScene(this.editScene.layerId, this.editData.rotation, this.editData);

            },
            changeSceneText() {
                changeSceneText(this.editScene.layerId, this.editData.text)
            },
            changeSceneShape() {
                changeSceneShape(this.editScene.layerId, this.editData.rectangular);
            },
            changeSceneTitleVisibility() {
                changeSceneTitleVisibility(this.editScene.layerId, this.editData.hideTitle);
            }
        },
        components: {
            RangeSlider,
        },
    }
</script>
